import { handleAttachmentFileChange, onAddFiles, uploadFile } from 'utils/attachment-util';

const AttachmentsInput = ({
  fileInputRef = null,
  files = [],
  setFiles = () => {},
  acceptTypes = 'image/*,application/pdf',
  allowedTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/webp', 'application/pdf'],
  maxSizeInBytes = 15 * 1024 * 1024,
  attachmentKey = '',
  makeBlob = true,
  multiple = false,
  capture,
  maxCount = null,
  getUrlApi = null,
  typeSlug = '',
  labelSourceClass = '',
  labelSlug = '',
}) => {
  const handleSuccess = async (validFiles) => {
    if (!validFiles?.length) return;

    const { updatedFiles, allFiles } = onAddFiles({ files, setFiles, newFiles: validFiles });
    updatedFiles?.forEach((item) => {
      uploadFile({
        item,
        attachmentKey,
        typeSlug,
        labelSourceClass,
        labelSlug,
        getUrlApi,
        files: allFiles,
        setFiles,
        makeBlob: makeBlob,
        isSvg: item?.file?.type === 'image/svg+xml',
      });
    });
  };

  return (
    <input
      type="file"
      ref={fileInputRef}
      multiple={multiple}
      style={{ display: 'none' }}
      accept={acceptTypes}
      capture={capture}
      onChange={(event) =>
        handleAttachmentFileChange({
          event,
          onSuccess: handleSuccess,
          allowedTypes,
          maxSizeInBytes,
          maxCount,
          currentCount: files.length,
        })
      }
    />
  );
};

export default AttachmentsInput;
